export enum MarkerClasses {
    BALANCE = 'extract-aum-annualreport-print-balancesheet',
    INCOME = 'extract-aum-annualreport-print-incomestatement',
    ACCOUNT_PROOF_BALANCE = 'extract-aum-annualreport-print-account-proof-balance',
    ACCOUNT_PROOF_INCOME = 'extract-aum-annualreport-print-account-proof-income',
    CASHFLOW = 'extract-aum-annualreport-print-cashflow',
    NOTES = 'extract-aum-annualreport-print-notes',
    AOP = 'extract-aum-annualreport-print-aop',
    EMS = 'extract-aum-annualreport-print-ems',
    FAS = 'extract-aum-annualreport-print-fas',
    COMPLEMENTARY_REPORT = 'extract-aum-annualreport-print-complementary-report-',
    TOC = 'extract-aum-annualreport-print-toc',
    COVER_PAGE = 'extract-aum-annualreport-print-cover',
    FINANCIAL_CLOSING_PROCESS = 'extract-aum-annualreport-print-fcp',
    APPENDIX = 'extract-aum-annualreport-print-appendix',
}
